import { render } from "./OnboardingTargets.vue?vue&type=template&id=c47fc690"
import script from "./OnboardingTargets.vue?vue&type=script&lang=js"
export * from "./OnboardingTargets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__